import * as React from 'react';
import { Alert, Button } from '@grandvisionhq/common';
import { Form } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { useSubscriptionAddressFormSlots } from '../../../slots/SubscriptionAddressFormSlotsContext.js';

const DeliveryAddressForm = ({ subscriptionForm , onChange , onSave , onCancel ,  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const isLoading = (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.saveFormCall.status) === 'loading';
    const isError = (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.saveFormCall.status) === 'failed';
    const { Slots: { form: FormTemplate  } ,  } = useSubscriptionAddressFormSlots();
    if (!FormTemplate) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Form, {
        name: "billingAddress",
        "data-t": "billingAddress",
        className: "subscription-deliveries__form",
        initialFormState: subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.state,
        onChange: ({ formState  })=>{
            onChange(formState);
        },
        onSubmit: ({ formState  })=>{
            onSave(formState);
        }
    }, isError && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: getFormattedLabel('account.subscription.detail.saveFailed', {
            parseLink: true
        })
    }), /*#__PURE__*/ React.createElement(FormTemplate, {
        addressType: "billingAddress"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "subscription-deliveries__note"
    }, /*#__PURE__*/ React.createElement("strong", null, getLabel('account.common.pleaseNote'), ":"), ' ', getLabel('account.subscription.detail.note')), /*#__PURE__*/ React.createElement("div", {
        className: "subscription-deliveries__button-block"
    }, /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('account.action.save'),
        className: "subscription-deliveries__button",
        isLoading: isLoading,
        type: "submit",
        "data-t": "save-delivery-address"
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('common.actions.cancel'),
        className: "subscription-deliveries__button",
        onClick: onCancel,
        variant: "outline"
    })));
};
var DeliveryAddressForm$1 = DeliveryAddressForm;

export { DeliveryAddressForm, DeliveryAddressForm$1 as default };
//# sourceMappingURL=DeliveryAddressForm.js.map
